module.exports = __webpack_public_path__ + "img/TEBUTRIS.b8648782.png";